// extracted by mini-css-extract-plugin
export default {"notificationsMenu":"styles_notificationsMenu__WPfjt","userIcon":"styles_userIcon__WhK3S","imgContainer":"styles_imgContainer__4DWrQ","redBullet":"styles_redBullet__3C9XP"};